'use strict';

import {EwSiteApp} from '../../app/ewsiteapp';
import 'angular-sanitize';

EwSiteApp.requires.push('ngSanitize');

EwSiteApp.controller('CategoriesIndexCtrl',['$scope', '$http', '$filter', '$log', '$timeout', function($scope, $http, $filter, $log, $timeout) {
	
	$scope.categories = [];
	
	$scope.loadData = function(){
		if($scope.dataUrl !== ''){
			$http({
				method: 'GET',
				url: $scope.dataUrl
			}).then(function(response){
				$scope.categories = response.data.list;
			}, function(response){
				console.log(['Error', response]);
			});
		}
	};
	
}]).directive('categoriesIndexList', function(){
	return {
		restrict: 'A',
		link: function (scope, element, attr) {
			scope.dataUrl = '';

			if(attr.dataUrl && attr.dataUrl !== ''){
				scope.dataUrl = unescape(attr.dataUrl);
				scope.loadData();
			}
		}
	};
});

EwSiteApp.controller('FaqSearchCtrl',['$scope', '$log', '$timeout', '$sce', 'ajaxSearch', function($scope, $log, $timeout, $sce, ajaxSearch){
	$scope.searchUrl = '';
	$scope.results = [];
	$scope.resultsLoading = false;
	$scope.sdquery = '';
	
	$scope.showResults = false;
	$scope.showEmptyNotice = false;
	$scope.showMinLengthNotice = false;
	
	$scope.total = 0;
	
	$scope.minChar = 3;
	var timeoutPromise = null;
	var timeoutDelay = 500;
		
	var ajaxRq = function(){
		ajaxSearch.search($scope.searchUrl, {
			sdquery: $scope.sdquery
		}).then(function(results){
			if($scope.sdquery === ''){
				$scope.clear();
				return;
			}
			
			if (results.list.length == 0) {
				$scope.showEmptyNotice = true;
				$scope.resultsLoading = false;
				$scope.total = 0;
				return;
			}
			
			$scope.results = results.list;
			$scope.total = results.total;
			$scope.resultsLoading = false;
		}, function(response){
			$log.error(response);
			$scope.resultsLoading = false;
		});
	};
	
	$scope.find = function(){
		if($scope.searchUrl !== ''){
			$scope.showResults = true;
			
			if ($scope.sdquery.length > $scope.minChar) {
				$scope.showMinLengthNotice = false;
				$scope.showEmptyNotice = false;
				$scope.resultsLoading = true;
				$scope.results = [];
			
				$timeout.cancel(timeoutPromise);

				timeoutPromise = $timeout(function(){
					ajaxRq();
				}, timeoutDelay, false);
			} else if ($scope.sdquery.length > 0) {
				$scope.showMinLengthNotice = true;
				$scope.showEmptyNotice = false;
				$scope.resultsLoading = false;
				$scope.results = [];
				$scope.total = 0;
			} else{
				$scope.clear();
			}
		}
	};
	
	$scope.clear = function() {
		$scope.sdquery = '';
		$scope.results = [];
		$scope.showResults = false;
		$scope.showEmptyNotice = false;
		$scope.showMinLengthNotice = false;
		$scope.total = 0;
	};
	
}]).directive('searchList', function(){
	return {
		restrict: 'A',
		link: function (scope, element, attr) {
			scope.searchUrl = '';

			if(attr.searchUrl && attr.searchUrl !== ''){
				scope.searchUrl = unescape(attr.searchUrl);
			}
		}
	};
});
